import script from "./peopleCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./peopleCheck.vue?vue&type=script&lang=ts&setup=true"

import "./peopleCheck.vue?vue&type=style&index=0&id=e4e02686&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4e02686"]])

export default __exports__